import { SUPPORTED_LOCALES, type SupportedLocale } from '@fleetcore/shared'
import { Check, Languages } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import { currentLocale, setLocale } from '../i18n'
import { Menu, MenuItem } from './ui/menu'

export function LanguageSwitcher() {
  const { t, i18n } = useTranslation()
  void i18n.language // re-render on switch

  const active = currentLocale()

  return (
    <Menu
      label={t('common:language.label')}
      trigger={() => (
        <span className="flex h-9 items-center gap-1.5 rounded-md px-2 text-sm text-foreground-muted transition-colors hover:bg-surface-hover hover:text-foreground">
          <Languages aria-hidden className="h-4 w-4" />
          <span className="uppercase">{active}</span>
        </span>
      )}
    >
      {(close) => (
        <>
          {SUPPORTED_LOCALES.map((locale: SupportedLocale) => (
            <MenuItem
              key={locale}
              selected={locale === active}
              onSelect={() => {
                void setLocale(locale)
                close()
              }}
            >
              <Check
                aria-hidden
                className={locale === active ? 'h-3.5 w-3.5' : 'h-3.5 w-3.5 opacity-0'}
              />
              {t(`common:language.${locale}`)}
            </MenuItem>
          ))}
        </>
      )}
    </Menu>
  )
}
